var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "columns is-gapless is-marginless is-centered" },
    [
      _c("div", { staticClass: "column is-narrow" }, [
        _c(
          "section",
          { staticClass: "is-auth-panel" },
          [_c("app-logo"), _c("router-view")],
          1
        ),
      ]),
      _vm._m(0),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-hidden-touch" }, [
      _c("section", { staticClass: "hero is-light is-fullheight is-bold" }, [
        _c("div", { staticClass: "hero-body dailydata-homepage" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }